import axios from 'axios';

const postNewSocialEmail = async (email: string, accessToken: string) => {
  try {
    const res = await axios.post('/api/auth/social-email', {
      data: { email },
    },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return res.status === 200;
  } catch (e) {
    return false;
  }
};

export default postNewSocialEmail;
